export enum Status {
    IDLE = 'idle',
    PENDING = 'pending',
    LOADING_MORE = 'loading-more',
    FULFILLED = 'fulfilled',
    REJECTED = 'rejected',
}
